export default __webpack_public_path__ + "static/BaseEfficiencyHistogram_color-ffd0f8dd9916c2566e4eae872c70446d.png";